<template>
    <v-container fluid grid-list-md style="padding-top: 48px;" v-if="$store.state.authenticated && coursecontentReady">
        <v-layout align-space-between justify-center column fill-height>
            <v-flex class="text-xs-center" v-if="!isQuiz">
                <h2 style="padding: 14px 0; border-bottom: 1px solid #3D68CC">{{course.name}}</h2>
            </v-flex>
            <v-flex grow style="padding-top: 21px;">
                <v-layout align-center justify-center row fill-height wrap>
                    <v-flex xs12 :md10="!isQuiz"> 
                        <VideoComponent v-if="isVideo && renderComponent" :content="coursecontent[page].content"/>
                        <TextComponent v-if="isText" :content="coursecontent[page].content"/> 
                        <Survey v-if="isQuiz" 
                        :content="coursecontent[page].content" 
                        @onSurveyStarted="surveyStarted"
                        :shuffle="coursecontent[page].shuffle == 1"
                        /> 
                    </v-flex>
                    <v-flex xs12 md2 v-if="!isQuiz && $vuetify.breakpoint.mdAndUp">
                        <h3>Schulungsinhalt</h3>
                        <v-layout column>
                            <v-flex
                                v-for="(heading, index) of headings"
                                :key="heading"
                                :class="{active: index === page}"
                            >{{ heading }}</v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-if="!isQuiz && $vuetify.breakpoint.xs " class="text-xs-center">
                <h4>Kapitel {{page + 1}} von {{coursecontent.length}}</h4>
            </v-flex>
            <v-flex shrink>
                <v-layout row align-center fill-height justify-space-around>
                    <v-flex 
                        xs6 
                        sm4
                        md3
                        lg2
                        >
                        <v-btn  
                            block
                            color="white"
                            v-if="page>0 && !surveyIsStarted" 
                            @click="setPage(page-1)"
                        >{{ isQuiz ? 'zur Schulung' : 'vorheriges Kapitel'}}
                        </v-btn>
                    </v-flex>
                    <v-flex v-if="!isQuiz && $vuetify.breakpoint.smAndUp " class="text-xs-center">
                        <h4>Kapitel {{page + 1}} von {{coursecontent.length}}</h4>
                    </v-flex>
                    <v-spacer v-else></v-spacer>
                    <v-flex 
                        xs6 
                        sm4 
                        md3 
                        lg2 
                        >
                        <template v-if="!isLastPage && !isQuiz">
                            <v-btn
                                v-if="!nextPageQuiz"  
                                block
                                color="white"
                                @click="setPage(page+1)"
                            >nächstes Kapitel</v-btn>
                            <v-btn  
                                color="white"
                                v-if="nextPageQuiz"
                                block
                                @click="setPage(page+1)"
                            >Zum Test</v-btn>
                        </template>                         
                        <v-btn  
                            v-if="isLastPage && !isQuiz"
                            block
                            color="white"
                            @click="setCompletedSurvey()"
                            >
                            Zum Dashboard
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md2 v-if="!isQuiz && $vuetify.breakpoint.smAndDown">
                <v-layout column :style="{paddingLeft: $vuetify.breakpoint.mdAndUp ? '0px' : '14px'}">
                    <h3>Schulungsinhalt</h3>
                    <v-flex
                        v-for="(heading, index) of headings"
                        :key="heading"
                        :class="{active: index === page}"
                    >{{ heading }}</v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
    
</template>

<script>
import VideoComponent from "@/components/VideoComponent";
import TextComponent from "@/components/TextComponent";
import Survey from "@/components/Survey";


export default {
    name: "Course",
    components: {
        VideoComponent,
        TextComponent,
        Survey
    },
    data: () => ({
        surveyIsStarted: false,
        renderComponent: true,
        course: {},
        coursecontent: [],
        coursecontentReady: false,
        page: 0
    }),
    
    computed: {
        nextPageQuiz() {
            if(this.page < this.coursecontent.length) {
                if(this.coursecontent[this.page+1] != undefined) {
                    if(this.coursecontent[this.page+1].type == 'quiz') return true
                    return false
                }
                return false
            }
            return false
        },
        headings() {
            return this.coursecontent.map(c => c.type !== 'quiz' ? c.heading ? c.heading : '' : 'Test');
        },
        isQuiz() {
            if(!this.coursecontent || !this.coursecontent[this.page]) return false;
            return this.coursecontent[this.page].type === 'quiz';
        },
        isVideo() {
            if(!this.coursecontent || !this.coursecontent[this.page]) return false;
            return this.coursecontent[this.page].type === 'video';
        },
        isText() {
            if(!this.coursecontent || !this.coursecontent[this.page]) return false;
            return this.coursecontent[this.page].type === 'text';
        },
        isLastPage() {
            if(!this.coursecontent) return false;
            return this.page === this.coursecontent.length -1;
        }
    },
    methods: { 
        surveyStarted(started) {
            console.log("surveyStarted", started)
            this.surveyIsStarted = started
        },
        savePage() {
            let self = this
            this.axios.axiosCall({
                url:
                    actionUrl + "rest/courses/page/" + this.$route.params.courseId + "/" + this.page,
                data: {
                    clientId: this.$store.state.currentClient.clientId
                },
                blockGui: false,
                success: function(response) {
                    console.log(response.data)
                }
            });
        },
        setPage(page) {
            //console.log(page)
            this.page = page
            this.savePage()
            if (this.coursecontent[page].type == 'video') {
                this.renderComponent = false
                this.$nextTick().then(() => {
                    // Add the component back in
                    this.renderComponent = true;
                })
            }
        },
        goToNextCourse(courseId){
            //console.log(courseId)
            this.$router.push('/course/' + courseId)
        },
        fetchContentDetails() {
            let self = this
            this.axios.axiosCall({
                url:
                    actionUrl + "rest/courses/detail/" + this.$route.params.courseId,
                data: {
                    clientId: this.$store.state.currentClient.clientId
                },
                blockGui: false,
                success: function(response) {
                    self.course = response.data;
                    self.page = response.data.contentPage
                    self.fetchContentCourse()
                    console.log('course', self.course, self.page)
                }
            });
        },
        fetchContentCourse() {
            let self = this
            this.coursecontentReady = false;
            this.axios.axiosCall({
                url:
                    actionUrl + "rest/courses/content/" + this.$route.params.courseId,
                data: {
                    clientId: this.$store.state.currentClient.clientId
                },
                blockGui: false,
                success: function(response) {
                    console.log("data",response.data, self.page)
                    self.coursecontent = response.data;
                    console.log("coursecontent", self.coursecontent[self.page])
                    self.coursecontentReady = true;
                }
            });
        },
        setCompletedSurvey() {
            if(!this.isLastPage) return;

            let self = this
            this.axios.axiosCall({
                url: actionUrl + "rest/courses/complete/" + this.$route.params.courseId,
                data: {
                    clientId: this.$store.state.currentClient.clientId
                },
                blockGui: false,
                success: function(response) {
                    self.passedAndSaved = true
                    self.$router.push({ name: 'Dashboard', params: { clientId: self.$route.params.clientId ? self.$route.params.clientId : undefined } })
                }
            })
        },
    },
    mounted() {
        let self = this;
        EventBus.$on('changeClient', (roles) => {
            //console.log('asdasdasd')
            // self.fetchContentDetails();
        });
    },
    created() {
        if(this.$store.state.userRole.role == "DST") {
            this.fetchContentDetails()
        } else {
            this.$router.push({ name: 'Dashboard', params: { clientId: this.$route.params.clientId ? this.$route.params.clientId : undefined} })
        }
    }
};
</script>

<style scoped>
.active {
    font-weight: bold;
    background-color: rgba(0,0,0,0.17);
    border-radius: 4px;
}
</style>
